module.exports = __webpack_public_path__ + "img/planting_01.95dcec3.webp";